import {SET_MAP_OBJECT, ADJUST_MAP_SIZE} from '../types'

const state = {
    mapObject: null,
};

const mutations = {
    [SET_MAP_OBJECT]: (state, mapObject) =>{
        state.mapObject = mapObject;
    },

    [ADJUST_MAP_SIZE]: (state) =>{
        let interval = setInterval(()=> {
            state.mapObject.invalidateSize();
        }, 4);
        setTimeout(() => {
            clearInterval(interval);
        }, 200);
    },
};

export default {
    state,
    mutations,
}